/**
 * Backpressure — reduz sampling de behavior sob pressão da fila.
 */

let pressureLevel = 0;

export function setQueuePressureLevel(level: number): void {
  pressureLevel = Math.max(0, Math.min(3, level));
}

export function getQueuePressureLevel(): number {
  return pressureLevel;
}

export function shouldReduceBehaviorSampling(): boolean {
  return pressureLevel >= 2;
}

export function getHeartbeatIntervalMultiplier(): number {
  if (pressureLevel >= 3) return 4;
  if (pressureLevel >= 2) return 2;
  return 1;
}
